import React from "react";
import { func, shape, string } from "prop-types";
import uuid from "uuid";

import CalendarOption from "./components/CalendarOption";
import CALENDAR_OPTIONS from "./constants/calendar-options";
import * as S from "./styled";

const TRIGGER_NODE = <S.AddToCalendarCTA>Add to Calendar</S.AddToCalendarCTA>;

const AddToCalendar = props => (
  <S.StyledTooltip
    position="right"
    theme="small"
    trigger="click"
    triggerNode={TRIGGER_NODE}
    width="auto"
    zIndex={999}
  >
    {CALENDAR_OPTIONS.map(calendarProps => (
      <CalendarOption
        {...calendarProps}
        key={uuid.v4()}
        handleAnalyticsEvent={openHouseId =>
          props.handleAnalyticsEvent(openHouseId)
        }
        openHouseData={props.openHouseData}
        openHouseId={parseInt(props.openHouseId, 10)}
      />
    ))}
  </S.StyledTooltip>
);

AddToCalendar.propTypes = {
  handleAnalyticsEvent: func,
  openHouseData: shape({
    id: string,
    listingAddress: string,
    listingLink: string,
    time: shape({
      startsAt: string,
      endsAt: string
    }),
    streamingUrl: string
  }).isRequired,
  openHouseId: string.isRequired
};

AddToCalendar.defaultProps = {
  handleAnalyticsEvent: () => {}
};

export default AddToCalendar;
